import { ColorModeScript } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

import { store } from './redux/store';
import { Provider } from 'react-redux';

import { surveyHydrate } from './redux/Features/Survey';
import { settingsHydrate } from './redux/Features/Settings';
import { BrowserRouter } from 'react-router-dom';

const getStateFromLocalStorage = () => {
    try {
        const persistedState = localStorage.getItem('reduxState');

        if (persistedState) return JSON.parse(persistedState);
    } catch (e) {
        console.log('LOCAL STORAGE GET ERROR: ', e);
    }
};

const localState = getStateFromLocalStorage();
if (localState) {
    store.dispatch(surveyHydrate(localState.survey));
    store.dispatch(settingsHydrate(localState.settings));
}
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    // <StrictMode>
    <BrowserRouter>
        <Provider store={store}>
            <ColorModeScript />
            <App />
        </Provider>
    </BrowserRouter>
    // </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
